import React from 'react'
import { Box, Text } from '@fundamentals'
import { Palette } from '@core/theme/color-palette-siteassist'

export const UserCardBanner: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Box bgcolor={Palette.Grey[800]} px={1.5} py={1}>
    <Text fontSize={12} color='common.white'>
      {children}
    </Text>
  </Box>
)
